import polyglotI18nProvider from "ra-i18n-polyglot";
import portugueseMessages from "@/i18n/portugueseMessages";

// Default i18n provider for the admin shell. Portuguese-only.
export const i18nProvider = polyglotI18nProvider(
  () => portugueseMessages,
  "pt",
  [{ locale: "pt", name: "Português" }],
  { allowMissing: true },
);
